// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
    width: 100%;
    border-radius: .5rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    padding: 1rem;
}
.credit-card-image {
    background-image: linear-gradient(to bottom,
        rgba(245, 246, 252, 0.296),
        rgba(38, 6, 74, 0.73)),
        url("https://th.bing.com/th/id/OIP.6QjTKmw3hLIR1x4tMsOG7AHaEW?w=264&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7");
    background-size: cover;
    background-position: top center;
    width: 10vw;
    height: 10vh;
    background-color: #d0eaff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.credit-card-image::before {
    content: "**** **** **** ****";
    color: white;
    width: max-content;
    background-color: rgb(146, 110, 148);
    text-align: center;
    font-size: .7rem;
}

  /* ////////add payment css ///////////////////////////////////////////////*/
    
.flip-box {
    background-color: transparent;
    width: max-content;
    height: max-content;
    perspective: 1000px;
    justify-content: space-between;
    gap:2rem;
}

.flip-box-inner {
    position: relative;
    text-align: center;
    transition: transform 2s ease-in-out;
    transform-style: preserve-3d;
    width:21vw;
    max-width: 21rem;
    height: 12vw;
    max-height: 12rem;
}  
.flip-box-front,
.flip-box-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
}
.flip-box-front {
    background-color: #bbb;
    color: black;
}
.flip-box-back {
    background-color: #555;
    color: white;
    transform: rotateY(180deg);
}
.card-image {
    background-image: linear-gradient(to bottom,
        rgba(245, 246, 252, 0.296),
        rgba(38, 6, 74, 0.73)),
        url("https://th.bing.com/th/id/OIP.6QjTKmw3hLIR1x4tMsOG7AHaEW?w=264&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7");
    background-size: cover;
    background-position: top center;
    width: 100%;
    border-radius: 15px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.card-number-display {
    font-size: 18px;
    text-align: center;
    margin-bottom: 2rem;
    white-space: nowrap;
    color: white;
    text-shadow: -1px -1px 0 rgba(255, 255, 255, 0.5),
        1px -1px 0 rgba(255, 255, 255, 0.5), -1px 1px 0 rgba(255, 255, 255, 0.5),
        1px 1px 0 rgba(255, 255, 255, 0.5);
    font-size: 1.2em;
}
.expiry_data_card {
    position: absolute;
    right: 2rem;
    bottom: 0.8rem;
    color: white;
    gap: 0rem;
}
.card-CVC{
    gap:1rem;
}
.card-CVC>p{
    font-weight: 800;
}
.card-CVC>span{
    padding: 0.5rem 1rem;
    border-radius:.5rem;
    border:1px solid rgb(255, 255, 255);
    background-color: rgba(255, 255,255, 0.2);
}
.card-input-form {
    padding: 10px;
    gap: 0.75rem;
    white-space: nowrap;
}
.card_labels {
    font-size: 0.8rem;
    font-weight: 400;
    text-align: left;
}

@media screen and (max-width: 1000px) {    
    .credit-card-image::before {
        content: "**** ****";
        background-color: rgb(234, 226, 234,0.3);
    }
}
@media (max-width: 800px) {
    .credit-card-image{
        width: 6rem;
        height: 3rem;
    }
    .credit-card-image::before {
        content: "****";
    }
    .subscriptionCard_parent {
        padding: 3.5rem 1rem;
        gap: 1rem;
        width: 100%;
        flex-direction: column;
    }
    .flip-box-inner {
        width:60vw;
        height: 30vw;
    }
}
@media screen and (max-width: 500px) {  
    .credit-card-image {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Subscription/Subscription.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,oBAAoB;IACpB,iDAAiD;IACjD,aAAa;AACjB;AACA;IACI;;;+GAG2G;IAC3G,sBAAsB;IACtB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;EAEE,2EAA2E;;AAE7E;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B;IAC5B,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,kBAAkB;IAClB,WAAW;IACX,YAAY;IAEZ,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,0BAA0B;AAC9B;AACA;IACI;;;+GAG2G;IAC3G,sBAAsB;IACtB,+BAA+B;IAC/B,WAAW;IACX,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ;;0CAEsC;IACtC,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,SAAS;AACb;AACA;IACI,QAAQ;AACZ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mCAAmC;IACnC,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,oBAAoB;QACpB,wCAAwC;IAC5C;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,oBAAoB;QACpB,SAAS;QACT,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,YAAY;IAChB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".card-container {\n    width: 100%;\n    border-radius: .5rem;\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n    padding: 1rem;\n}\n.credit-card-image {\n    background-image: linear-gradient(to bottom,\n        rgba(245, 246, 252, 0.296),\n        rgba(38, 6, 74, 0.73)),\n        url(\"https://th.bing.com/th/id/OIP.6QjTKmw3hLIR1x4tMsOG7AHaEW?w=264&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7\");\n    background-size: cover;\n    background-position: top center;\n    width: 10vw;\n    height: 10vh;\n    background-color: #d0eaff;\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.credit-card-image::before {\n    content: \"**** **** **** ****\";\n    color: white;\n    width: max-content;\n    background-color: rgb(146, 110, 148);\n    text-align: center;\n    font-size: .7rem;\n}\n\n  /* ////////add payment css ///////////////////////////////////////////////*/\n    \n.flip-box {\n    background-color: transparent;\n    width: max-content;\n    height: max-content;\n    perspective: 1000px;\n    justify-content: space-between;\n    gap:2rem;\n}\n\n.flip-box-inner {\n    position: relative;\n    text-align: center;\n    transition: transform 2s ease-in-out;\n    transform-style: preserve-3d;\n    width:21vw;\n    max-width: 21rem;\n    height: 12vw;\n    max-height: 12rem;\n}  \n.flip-box-front,\n.flip-box-back {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n}\n.flip-box-front {\n    background-color: #bbb;\n    color: black;\n}\n.flip-box-back {\n    background-color: #555;\n    color: white;\n    transform: rotateY(180deg);\n}\n.card-image {\n    background-image: linear-gradient(to bottom,\n        rgba(245, 246, 252, 0.296),\n        rgba(38, 6, 74, 0.73)),\n        url(\"https://th.bing.com/th/id/OIP.6QjTKmw3hLIR1x4tMsOG7AHaEW?w=264&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7\");\n    background-size: cover;\n    background-position: top center;\n    width: 100%;\n    border-radius: 15px;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n}\n.card-number-display {\n    font-size: 18px;\n    text-align: center;\n    margin-bottom: 2rem;\n    white-space: nowrap;\n    color: white;\n    text-shadow: -1px -1px 0 rgba(255, 255, 255, 0.5),\n        1px -1px 0 rgba(255, 255, 255, 0.5), -1px 1px 0 rgba(255, 255, 255, 0.5),\n        1px 1px 0 rgba(255, 255, 255, 0.5);\n    font-size: 1.2em;\n}\n.expiry_data_card {\n    position: absolute;\n    right: 2rem;\n    bottom: 0.8rem;\n    color: white;\n    gap: 0rem;\n}\n.card-CVC{\n    gap:1rem;\n}\n.card-CVC>p{\n    font-weight: 800;\n}\n.card-CVC>span{\n    padding: 0.5rem 1rem;\n    border-radius:.5rem;\n    border:1px solid rgb(255, 255, 255);\n    background-color: rgba(255, 255,255, 0.2);\n}\n.card-input-form {\n    padding: 10px;\n    gap: 0.75rem;\n    white-space: nowrap;\n}\n.card_labels {\n    font-size: 0.8rem;\n    font-weight: 400;\n    text-align: left;\n}\n\n@media screen and (max-width: 1000px) {    \n    .credit-card-image::before {\n        content: \"**** ****\";\n        background-color: rgb(234, 226, 234,0.3);\n    }\n}\n@media (max-width: 800px) {\n    .credit-card-image{\n        width: 6rem;\n        height: 3rem;\n    }\n    .credit-card-image::before {\n        content: \"****\";\n    }\n    .subscriptionCard_parent {\n        padding: 3.5rem 1rem;\n        gap: 1rem;\n        width: 100%;\n        flex-direction: column;\n    }\n    .flip-box-inner {\n        width:60vw;\n        height: 30vw;\n    }\n}\n@media screen and (max-width: 500px) {  \n    .credit-card-image {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
